import { z } from "zod";

import {
	ChillnnRoomAndAirHostPricePlanMappingItemInputSchema,
	SiteControllerSettingAirHostBaseInfoInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

export const siteControllerSettingAirHostInputZodSchema = SiteControllerSettingAirHostBaseInfoInputSchema.extend({
	airHostSettings: z.object({
		airHostAPIAccessToken: z.string().min(1, { message: "アクセストークンは必須入力です" }).max(100),
		airHostPartnerID: z.string().min(1, { message: "パートナーIDは必須入力です" }).max(100),
		airHostPropertyID: z
			.string()
			.min(1, { message: "施設IDは必須入力です" })
			.max(50)
			.uuid({ message: "施設IDの形式が正しくありません。入力内容を今一度ご確認ください" }),
		chillnnRoomAndAirHostPricePlanMappings: z.array(
			ChillnnRoomAndAirHostPricePlanMappingItemInputSchema.extend({
				chillnnRoomID: z.string().min(1, { message: "CHILLNNの部屋を選択してください" }),
				airHostPlanID: z.string().min(1, { message: "AirHostの料金プランを選択してください" }),
			}),
		),
	}),
});

export type SiteControllerSettingAirHostInputZodSchemaType = z.infer<typeof siteControllerSettingAirHostInputZodSchema>;
